import { render } from "./leave-types-modal.vue?vue&type=template&id=368ac701"
import script from "./leave-types-modal.vue?vue&type=script&lang=js"
export * from "./leave-types-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__